import { Action } from 'redux';
import { ValidEmail } from '@dev/ee-api/ee-api-models';

export interface AddValidEmailErrorMessage {
    message: string;
    messageId?: string;
    messageParts?: string[];
}

export enum ValidEmailsActionTypes {
    VALIDEMAILS_FETCH_START = '@@validEmails/VALIDEMAILS_FETCH_START',
    VALIDEMAILS_FETCH_SUCCESS = '@@validEmails/VALIDEMAILS_FETCH_SUCCESS',
    VALIDEMAILS_FETCH_ERROR = '@@validEmails/VALIDEMAILS_FETCH_ERROR',
    VALIDEMAILS_RESEND_VERIFICATION = '@@validEmails/VALIDEMAILS_RESEND_VERIFICATION',
    VALIDEMAILS_DELETE = '@@validEmails/VALIDEMAILS_DELETE',
    VALIDEMAILS_DELETE_SUCCESS = '@@validEmails/VALIDEMAILS_DELETE_SUCCESS',
    VALIDEMAILS_DELETE_ERROR = '@@validEmails/VALIDEMAILS_DELETE_ERROR',
    VALIDEMAILS_ADD = '@@validEmails/VALIDEMAILS_ADD',
    VALIDEMAILS_ADD_SUCCESS = '@@validEmails/VALIDEMAILS_ADD_SUCCESS',
    VALIDEMAILS_ADD_ERROR = '@@validEmails/VALIDEMAILS_ADD_ERROR',
    VALIDEMAILS_SINGLE_VIEW = '@@validEmails/VALIDEMAILS_SINGLE_VIEW',
    VALIDEMAILS_SINGLE_VIEW_DELETE = '@@validEmails/VALIDEMAILS_SINGLE_VIEW_DELETE',
}

export interface ValidEmailsFetchStartAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_FETCH_START;
}
export interface ValidEmailsFetchSuccessAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_FETCH_SUCCESS;
    payload: {
        emails: ValidEmail[];
    };
}
export interface ValidEmailsFetchErrorAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_FETCH_ERROR;
}
export interface ResendEmailVerificationAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_RESEND_VERIFICATION;
    payload: {
        email: string;
    };
}
export interface DeleteValidEmailAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_DELETE;
    payload: {
        email: string[];
    };
}
export interface DeleteValidEmailSuccessAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_DELETE_SUCCESS;
    payload: {
        emails: ValidEmail[];
    };
}
export interface DeleteValidEmailErrorAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_DELETE_ERROR;
}
export interface AddValidEmailAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_ADD;
    payload: {
        email: string;
    };
    meta: Record<string, unknown>;
}
export interface AddValidEmailSuccessAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_ADD_SUCCESS;
    payload: {
        emails: ValidEmail[];
    };
    meta: Record<string, unknown>;
}
export interface AddValidEmailErrorAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_ADD_ERROR;
    payload: AddValidEmailErrorMessage;
    meta: Record<string, unknown>;
    error: boolean;
}
export interface AddSingleEmailViewAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_SINGLE_VIEW;
    payload: {
        email: string;
    };
}
export interface DeleteSingleEmailViewAction extends Action {
    type: ValidEmailsActionTypes.VALIDEMAILS_SINGLE_VIEW_DELETE;
    payload: {
        email: null;
    };
}

export interface ValidEmailsState {
    loadingEmails?: boolean;
    emails?: ValidEmail[];
    errorMsg?: string;
    singleViewEmail?: ValidEmail;
}
